export default {"src":"/_next/static/media/ellipse.637a879c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};